<div class="opace-bg">
  <section class="synonymize-container">

    <nav class="modal-bar">
      <h4 *ngIf="isModeHierarchy">Edit Keyword Hierarchy</h4>
      <h4 *ngIf="!isModeHierarchy">Edit Keyword Synonyms</h4>
      <i class="fas fa-lg fa-times" data-closeModal="close" *ngIf="!isLoading" (click)="closeModal()"
        style="cursor: pointer;"></i>
    </nav>

    <div class="syn-headers">
      <!-- First Row of Header -->
      <div class="input-group">
        <input #search type="text" style="text-transform: capitalize;" class="form-control editable"
          placeholder="Search Keywords" [(ngModel)]="searchQuery" (keyup)="searchChanged()">
        <button [disabled]="page === 0" type="button" class="btn btn-sm btn-outline-secondary"
          (click)="changePage('keywords', page - 1)">
          <span class="btn-txt">Prev</span>
          <i class="fas fa fa-arrow-left ms-2"></i>
        </button>
        <button [disabled]="page === numberPages - 1 || filteredKeywords.length <= keywordsPerPage" type="button"
          class="btn btn-sm btn-outline-secondary" (click)="changePage('keywords', page + 1)" style="margin-left: 4px;">
          <span class="btn-txt">Next</span>
          <i class="fas fa fa-arrow-right ms-2"></i>
        </button>
      </div>

      <div style="margin: auto;">
        <app-slant-button [disabled]="isLoading" btnColor="red" *ngIf="isModeHierarchy" tooltip="Switch to Synonym Editor" (click)="toggleEditingMode()"
          btnIconClass="fas fa-boxes" leftMode="true"> Hierarchy
        </app-slant-button>

        <app-slant-button [disabled]="isLoading" btnColor="red" *ngIf="!isModeHierarchy" tooltip="Switch to Hierarchy Editor" (click)="toggleEditingMode()"
          btnIconClass="fas fa-tags" leftMode="true"> Synonyms
        </app-slant-button>
      </div>
      <div class="split-synonyms-actions">
        <div></div>
        <div class="input-group" style="display: flex; align-items: center; justify-content: space-between;">
          <!-- If the look of the buttons stretching out remove the form-control and input-group from them-->
          <div>
            <div tabindex="-1" class="save-tab-group" #saveButtonTabStop></div>
            <app-slant-button tabindex="-1" [disabled]="numChangesMade == 0" btnColor="green" (click)="saveChanges()"
              tooltip="Save Changes" class="save-tab-group" btnIconClass="fas fa fa-save"> Save
            </app-slant-button>

            <app-slant-button tabindex="-1" [disabled]="numChangesMade == 0" btnColor="gray" (click)="cancelChanges()" style="margin-left: 10px;"
              tooltip="Revert Changes" class="save-tab-group" btnIconClass="fas fa fa-undo"> Undo
            </app-slant-button>
          </div>
          <!-- Split Between Save/Undo and Next/Back btns-->
          <div>
            <button tabindex="-1" [disabled]="relatedWordsPage === 0" type="button"
            class="btn btn-sm btn-outline-secondary save-tab-group" (click)="changePage('related', relatedWordsPage - 1)"
            style="margin-left: 4px;">
            <i class="fas fa fa-arrow-left"></i>      
          </button>
          <button tabindex="-1"
            [disabled]="relatedWordsPage === numberRelatedPages - 1 || relatedKeywords.length <= keywordsPerPage"
            type="button" class="btn btn-sm btn-outline-secondary save-tab-group"
            (click)="changePage('related', relatedWordsPage + 1)" style="margin-left: 4px;">
            <i class="fas fa fa-arrow-right"></i>
          </button>
          </div>
        </div>
      </div>

      <!-- Second Row of Header -->
      <div style="text-align: right;">Page {{page + 1}} of {{numberPages || 1}}</div>
      <div></div>
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div *ngIf="!isModeHierarchy">Selected Keyword: <strong>{{ selectedKeyword.keyword }}</strong></div>
        <div *ngIf=" isModeHierarchy">Parent Keyword: <strong>{{ selectedKeyword.keyword }}</strong></div>
        <div>Page {{ relatedWordsPage + 1 }} of {{ numberRelatedPages || 1 }}</div>
      </div>
    </div>

    <div id="syn-split-view">
      <section id="syn-selected-pane" class="syn-pane" #keywordsList>
        <div tabindex="0" *ngFor="let keyword of visableKeywords" (click)="selectKeyword(keyword)"
          (dblclick)="addRelated()"
          [ngClass]="keyword.keyword === activeKeyword?.keyword ? 'keyword syn-selected' : 'keyword'"
          style="cursor: pointer;" attr.data-uid={{keyword.uid}}>{{ keyword.keyword }}
        </div>
        <div *ngIf="visableKeywords.length === 0" class="keyword">No keywords match your query</div>
      </section>


      <div id="syn-middle-pane" class="syn-pane">
        <button tabindex="-1" class="btn btn-lg" matTooltip="Add As Synonym" (click)="addRelated()"
          [disabled]="!canAddRelated" [ngClass]="canAddRelated? 'arrow-enabled': ''">
          <i class="fas fa-arrow-alt-right fa-4x"></i>
        </button>
        <button tabindex="-1" class="btn btn-lg" matTooltip="Remove As Synonym" (click)="removeRelated()"
          [disabled]="!canRemoveRelated" [ngClass]="canRemoveRelated? 'arrow-enabled' : ''">
          <i class="fas fa-arrow-alt-left fa-4x"></i>
        </button>
      </div>

      <div id="syn-options-pane" class="syn-pane" #relatedList>
        <div tabindex="0" *ngFor="let keyword of visableRelatedKeywords" (click)="selectKeyword(keyword)"
          (dblclick)="removeRelated()"
          [ngClass]="keyword.keyword === activeKeyword?.keyword ? 'keyword syn-selected' : 'keyword'"
          style="cursor: pointer;" attr.data-uid={{keyword.uid}}>{{ keyword.keyword }}
        </div>
        <div tabindex="0" #lastRelatedTabStop></div>
      </div>
    </div>
  </section>
</div>